import React, { useEffect, useState } from "react";
import "./Donations.css";
import BASE_URL from "../../services/api";

export default function Donations() {
  const [causes, setCauses] = useState([]);

  useEffect(() => {
    fetch(`${BASE_URL}/admin/causes/transfer-pending`)
      .then((res) => res.json())
      .then((data) => setCauses(data))
      .catch(() => alert("Failed to load pending transfers"));
  }, []);

  const handleTransferDone = async (causeId) => {
    try {
      const res = await fetch(`${BASE_URL}/admin/cause/transfer-complete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cause_id: causeId }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.msg);

      alert("Transfer marked as completed");

      // remove from list after transfer
      setCauses((prev) => prev.filter((c) => c.id !== causeId));
    } catch (err) {
      alert(err.message || "Failed to update transfer");
    }
  };

  return (
    <div className="donations-page">
      <h2 className="page-title">Transfer Management</h2>

      <div className="donations-list">
        {causes.length === 0 ? (
          <p>No pending transfers</p>
        ) : (
          causes.map((cause) => (
            <div className="donation-card" key={cause.id}>
              <div className="donation-info">
                <p>
                  <span>Cause:</span> {cause.title}
                </p>
                <p>
                  <span>Total Collected:</span> ₹{cause.amount_collected}
                </p>
              </div>

              <div className="donation-actions">
                <span className="status-badge status-pending">
                  Pending Transfer
                </span>

                <button
                  className="transfer-btn"
                  onClick={() => handleTransferDone(cause.id)}
                >
                  Mark Transfer Done
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
